var map = {
	"./logos/broshura/main-broshura.png": 60741,
	"./logos/broshura/main-broshura@2x.png": 75791,
	"./logos/folderscheck/main-folderscheck.png": 8317,
	"./logos/folderscheck/main-folderscheck@2x.png": 8967,
	"./logos/handelsangebote/main-handelsangebote.png": 21403,
	"./logos/handelsangebote/main-handelsangebote@2x.png": 97381,
	"./logos/main-en_AU.png": 44126,
	"./logos/main-en_AU@2x.png": 50838,
	"./logos/main-en_NZ.png": 8956,
	"./logos/main-en_NZ@2x.png": 14860,
	"./logos/main-en_US.png": 89684,
	"./logos/main-en_US@2x.png": 84100,
	"./logos/main-es_ES.png": 72803,
	"./logos/main-es_ES@2x.png": 6445,
	"./logos/main-es_MX.png": 49544,
	"./logos/main-es_MX@2x.png": 87184,
	"./logos/main-fr_FR.png": 67867,
	"./logos/main-fr_FR@2x.png": 37509,
	"./logos/main-id_ID.png": 52137,
	"./logos/main-id_ID@2x.png": 10891,
	"./logos/main-it_IT.png": 24009,
	"./logos/main-it_IT@2x.png": 16843,
	"./logos/main-pt_BR.png": 85583,
	"./logos/main-pt_BR@2x.png": 5121,
	"./logos/main-pt_PT.png": 73943,
	"./logos/main-pt_PT@2x.png": 58601,
	"./logos/promoqui/main-promoqui.png": 60993,
	"./logos/promoqui/main-promoqui@2x.png": 30755,
	"./logos/prospecto/main-prospecto.png": 9893,
	"./logos/prospecto/main-prospecto@2x.png": 90127,
	"./logos/tiendeo/main-tiendeo.png": 66067,
	"./logos/tiendeo/main-tiendeo@2x.png": 62589,
	"./logos/volantinofacile/main-volantinofacile.png": 38227,
	"./logos/volantinofacile/main-volantinofacile@2x.png": 5725,
	"./logos/wogibtswas/main-wogibtswas.png": 95581,
	"./logos/wogibtswas/main-wogibtswas@2x.png": 76999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32364;